export const normalizarPlaca = (placa: string): string => {
  return placa.toUpperCase().replace(/[^A-Z0-9]/g, "")
}

export const normalizarCombustivel = (combustivel?: string | null): string | null => {
  if (!combustivel) return null

  const normalizado = combustivel
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim()

  if (!normalizado) return null

  if (normalizado.includes("flex")) return "flex"

  const temGasolina = normalizado.includes("gasolina")
  const temEtanol = normalizado.includes("etanol") || normalizado.includes("alcool")

  if (temGasolina && temEtanol) return "flex"
  if (normalizado.includes("diesel")) return "diesel"
  if (normalizado.includes("gnv")) return "gnv"
  if (normalizado.includes("eletric")) return "eletrico"
  if (normalizado.includes("hibrid")) return "hibrido"
  if (temEtanol) return "etanol"
  if (temGasolina) return "gasolina"

  return null
}
